import { Pipe, PipeTransform } from '@angular/core';
import { IPlacedDevice } from '../../enclosure/models/grid.model';
import { IsProductDeprecatedPipe } from './is-product-deprecated.pipe';

@Pipe({
    name: 'thereAreDeprecatedProducts',
    standalone: false
})
export class ThereAreDeprecatedProductsPipe implements PipeTransform {

  transform(devices: IPlacedDevice[]): unknown {
    return devices?.some(device => new IsProductDeprecatedPipe().transform(device?.device?.status));
  }

}
